import { render } from "./LocalUsersEdit.vue?vue&type=template&id=e0860c34&scoped=true&ts=true"
import script from "./LocalUsersEdit.vue?vue&type=script&lang=ts"
export * from "./LocalUsersEdit.vue?vue&type=script&lang=ts"

import "./LocalUsersEdit.vue?vue&type=style&index=0&id=e0860c34&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0860c34"]])

export default __exports__